import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {Container} from '@mui/material';
import {LoadingSpinner, Modal} from '@timmons-group/shared-react-components';

const Explorer = ({portalApp}) => {
  const [portalAppFullUrl, setPortalAppFullUrl] = useState(null);
  const [portalAppFullUrlLoading, setPortalAppFullUrlLoading] = useState(true);
  const [portalUrl, setPortalUrl] = useState(null);
  const [portalUrlLoading, setPortalUrlLoading] = useState(true);
  const [open, setOpen] = useState(true);

  const handleOk = () => {
    localStorage.setItem('popupSeen', true);
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  }

  useEffect(() => {
    const popupSeen = localStorage.getItem('popupSeen');
    if (popupSeen) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, []);

  // fetch portalAppFullUrl with useEffect
  useEffect(() => {
    if (!portalAppFullUrl) {
      setPortalAppFullUrlLoading(true);

      let url = '/api/config/arcConfig?arcConfigParam=';
      if (portalApp === 'explorer') {
        url += 'explorerAppFullUrl';
      } else if (portalApp === 'dashboard') {
        url += 'dashboardAppFullUrl';
      }

      axios.get(url).then(res => {
        setPortalAppFullUrl(res.data);
      }).catch(err => {
        console.log('err', err);
        setPortalAppFullUrl({ error: 'Config not found' });
      }).finally(() => {
        setPortalAppFullUrlLoading(false);
      });
    } else {
      setPortalAppFullUrlLoading(false);
    }
  }, [portalAppFullUrl]);

  // fetch portalUrl with useEffect
  useEffect(() => {
    if (!portalUrl) {
      setPortalUrlLoading(true);
      axios.get('/api/config/arcConfig?arcConfigParam=portal').then(res => {
        setPortalUrl(res.data);
      }).catch(err => {
        console.log('err', err);
        setPortalUrl({ error: 'Config not found' });
      }).finally(() => {
        setPortalUrlLoading(false);
      });
    }
  }, [portalUrl]);

  if (portalAppFullUrlLoading || portalUrlLoading) {
    return (
      <>
        <LoadingSpinner isActive={true} message={`Loading ${portalApp}...`}/>
      </>
    );
  } else {
    return (
      <>
        <Modal
          sx={{
            '& .MuiTypography-modalTitle': {
              fontSize: '1.5rem',
            },
          }}
          title="Warning"
          open={open}
          onOk={handleOk}
          okLabel="Don't show this again"
          onCancel={handleCancel}
          aria-labelledby="popup-modal"
          aria-describedby="popup-modal"
        >
          <div>
            <h3 id="popup-modal">Allow Pop-ups</h3>
            <p id="popup-description">
              You must allow pop-ups from this site in your browser settings in order to use the map Explorer.
            </p>
          </div>
        </Modal>

        <Container maxWidth={false} disableGutters>
          <iframe
            style= {{
              position: 'absolute',
              height: 'calc(100% - 64px)', // 64px is the height of the app bar - might be able to nab the value from the theme if we need to be more dynamic
              width:'100%',
              border: 'none'}}
            src={portalAppFullUrl}
          ></iframe>
        </Container>
      </>
    );
  }
}

export default Explorer;
